import React from 'react'
import '../App.css';
import { Navbar, NLV_Header, NLV_Adn40, NLV_Video_semblanza, 
  NLV_Recomendados, NLV_Tiendas, NLV_Descarga, NLV_Coleccion, Footer } from '../container';
import Home_cinco from "../container/Nuevo_libro/libro_vd_more/Libro_vd_more";


const NuevoLibro = () => {
  return (
    <div class="App_DB LibroVerde">
        <Navbar link="https://www.gandhi.com.mx/ideas-que-transforman-sociedades-para-cambiar-al-mundo"/> 
        <NLV_Header/>
        <NLV_Adn40/>
        <NLV_Video_semblanza/>
        <NLV_Recomendados/>
        <NLV_Tiendas/>
        <NLV_Descarga/>
        <NLV_Coleccion/>
        <Home_cinco/>
        <Footer/>
    </div>
  )
}

export default NuevoLibro
